'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import useBookingStore from '@/store/useBookingStore';

/**
 * Clears `/book` wizard state when the user lands on marketing home or the checkout success page,
 * so a new visit to `/book` starts fresh.
 */
export default function ResetBookingOnRoutes() {
  const pathname = usePathname();
  const reset = useBookingStore((s) => s.reset);

  useEffect(() => {
    if (!pathname) return;
    if (pathname === '/' || pathname.startsWith('/book/success')) {
      reset();
    }
  }, [pathname, reset]);

  return null;
}
